import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { NewsService } from 'src/app/services/news.service';
import { News } from 'src/app/classes/news';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


@Component({
	selector: 'app-news-print',
	templateUrl: './news-print.component.html',
	styleUrls: [ './news-print.component.css' ]
})
export class NewsPrintComponent implements OnInit, OnDestroy {


	subscriptions = new Subscription();

	news = new News();
  contactTitle = "";
  contactFirstName = "";
  contactFamilyName = "";
  contactPhone = "";
  contactEmail = "";

	newsContent: SafeHtml = "";


	constructor(
		private newsService: NewsService,
		private activatedRoute: ActivatedRoute,
		public domSanitizer: DomSanitizer,
	) {}


	ngOnInit() {

		this.activatedRoute.queryParams.subscribe( params => {

			if( !params['id'] ) return;

			this.newsService.getNews().subscribe( news => {
				if( !news || !news.length ) return;
				const existingNews = news.find( n => n.id == params['id'] );
				if( !existingNews ) return;

				this.news = existingNews;
    this.contactFirstName = this.news.contactFirstName;
    this.contactFamilyName = this.news.contactFamilyName;
    this.contactTitle = this.news.contactTitle;
    this.contactPhone = this.news.contactPhone;
    this.contactEmail = this.news.contactEmail;

				this.newsContent = this.domSanitizer.bypassSecurityTrustHtml(this.news.content);

				window.setTimeout( () => {

					window.print();

				}, 400 );

			});

		});


	}

	ngOnDestroy() {

		this.subscriptions.unsubscribe();

	}



}

